module.exports = __webpack_public_path__ + "assets/img/search_empty.a1397d5a.png";